<template>
  <ul id="bsk_aside_panel">
    <li><a @click.prevent.stop="backToTop" id="asideTop" class="hide"></a></li>
    <li><a @click id="asideQQ" class="hide" target="_blank"
           href="https://work.weixin.qq.com/kfid/kfc318239c3a5102a0c"></a></li>
    <li><a @click.prevent.stop class="hide" id="asideWeixin"></a>
      <img src="../../common/imgs/index_weixin.png"></li>
    <li><a @click.prevent.stop class="hide" id="asideWeibo"></a>
      <img src="../../common/images/shipinhao.png"></li>
  </ul>
</template>
<script>
document.onscroll = function () {
  var scrollTop = document.body.scrollTop == 0 ? document.documentElement.scrollTop : document.body.scrollTop;
  if (scrollTop > window.screen.height - 200) {
    $('#asideTop').removeClass('hide');
    $('#asideQQ').removeClass('hide');
    $('#asideWeixin').removeClass('hide');
    $('#asideWeibo').removeClass('hide');
  } else {
    $('#asideTop').addClass('hide');
    $('#asideQQ').addClass('hide');
    $('#asideWeixin').addClass('hide');
    $('#asideWeibo').addClass('hide');
  }
}
export default {
  name: 'aside-panel',
  methods: {
    backToTop: function () {
      var doc = document.body.scrollTop == 0 ? $(document.documentElement) : $('body');
      doc.animate({'scrollTop': 0});
    }
  }
}

</script>
<style scope>
#bsk_aside_panel {
  width: 48px;
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 800;
}

#bsk_aside_panel, #bsk_aside_panel * {
  margin: 0;
  padding: 0;
}

#bsk_aside_panel li {
  width: 48px;
  height: 48px;
  margin-bottom: 5px;
  position: relative;
  list-style: none;
}

#bsk_aside_panel li a {
  width: 100%;
  height: 100%;
  display: block;
  background-color: #ffbc42;
  background-repeat: no-repeat;
  border-radius: 8px;
  cursor: pointer;
}

#asideTop.hide {
  display: none;
}

#asideTop {
  background-image: url("../../common/imgs/index_icons.png");
  background-position: 2px 0;
  background-size: 130%;
  position: relative;
}

#asideTop:after {
  content: "";
  display: block;
  height: 48px;
  width: 0;
  overflow: hidden;
  font-size: 14px;
  color: #fff;
}

#asideTop:hover:after {
  content: "返回顶部";
  width: 82px;
  height: 48px;
  line-height: 48px;
  position: absolute;
  top: 0;
  right: 48px;
  background-color: inherit;
  text-align: center;
  -webkit-transition: width .5s ease;
  -ms-transition: width .5s ease;
  -moz-transition: width .5s ease;
  -o-transition: width .5s ease;
  transition: width .5s ease;
  border-radius: 8px;
}

#asideQQ {
  background-image: url("../../common/images/service_white.png");
  background-size: 30px 30px;
  background-position: 9px 9px;
}

#asideQQ:after {
  content: "";
  display: block;
  height: 48px;
  width: 0;
  overflow: hidden;
  font-size: 14px;
  color: #fff;
}

#asideQQ:hover:after {
  content: "在线客服";
  width: 82px;
  height: 48px;
  line-height: 48px;
  position: absolute;
  top: 0;
  right: 48px;
  background-color: inherit;
  text-align: center;
  -webkit-transition: width .5s ease;
  -ms-transition: width .5s ease;
  -moz-transition: width .5s ease;
  -o-transition: width .5s ease;
  transition: width .5s ease;
  border-radius: 8px;
}

#asideWeixin {
  background-image: url("../../common/images/wechat_white.png");
  background-size: 35px 35px;
  background-position: 7px 7px;
}

#asideWeibo {
  background-image: url("../../common/images/live_white.png");
  background-size: 30px 30px;
  background-position: 9px 9px;
}

#asideWeixin ~ img, #asideWeibo ~ img {
  width: 0px;
  height: 122px;
  display: none;
  position: absolute;
  top: -37px;
  right: 48px;
}

#asideWeixin:hover ~ img, #asideWeibo:hover ~ img {
  width: 128px;
  height: 122px;
  display: block;
}

.hide {
  /*display:none !important;*/
}

</style>



// WEBPACK FOOTER //
// src/components/Layout/AsidePanel.vue